export enum DeductionType {
    CHILD_SUPPORT = 'child_support',
    MISCELLANEOUS = 'miscellaneous',
    MISCELLANEOUS_GARNISHMENT = 'miscellaneous_garnishment'
}
